export {
  createAudioPlayer,
  setAudioModeAsync,
  useAudioPlayer,
  useAudioPlayerStatus,
} from "expo-audio";
export type {
  AudioLockScreenOptions,
  AudioMetadata,
  AudioMode,
  AudioPlayer,
  AudioSource,
  AudioStatus,
} from "expo-audio";
